import React from "react";
import "../Styles/Feefrequency.css";


export default function Monthly() {
    return (
        <div className="monthly-container my-4">
            {/* Header */}
            <div className="special-header panel-white-all">
            <h4 className="page-title ">Monthly</h4>
            </div>

            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Fee Frequency ID</td>
                                    <td>2</td>

                                </tr>
                                <tr>

                                    <td>Fee Frequency Name</td>
                                    <td>One time</td>

                                </tr>
                                <tr>

                                    <td>Fee Frequency Status</td>
                                    <td>Active</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>

    );

}